import Axios from 'axios';
import Cookies from 'js-cookie';
import { createBrowserHistory, createMemoryHistory } from 'history';
import { AUTH_TOKEN, AUTH_TOKEN_WEB } from '../config/constants';

const DEBUG = process.env.NODE_ENV === 'development';
export const history = typeof window !== 'undefined' ? createBrowserHistory() : createMemoryHistory();

const axiosInstance = Axios.create({
  timeout: 3 * 60 * 1000,
  baseURL: process.env.RAZZLE_REACT_APP_API_DOMAIN,
});

axiosInstance.interceptors.request.use(
  (config) => {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${Cookies.get(AUTH_TOKEN)}`;
    // Todo job_member
    return config;
  },
  (error) => {
    if (DEBUG) {
      console.error('✉️ ', error);
    }

    return Promise.reject(error);
  },
);

const logout = () => {
  Cookies.remove(AUTH_TOKEN);
  Cookies.remove(AUTH_TOKEN_WEB);
  Cookies.remove('refreshToken');
  Cookies.remove('hidden_bottom_nav');
  // Todo job_member

  history.push('/');
};
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (DEBUG) {
      console.error('✉️ ', error);
    }

    const originalConfig = error.config;
    if (error.response.status !== 401) {
      return Promise.reject(error);
    }
    const refreshToken = Cookies.get('refreshToken');
    if (!refreshToken) {
      return logout();
    }
    return Axios.post(`${process.env.RAZZLE_REACT_APP_API_DOMAIN}/auth/request-access-token`, {
      refreshToken,
    })
      .then((res) => {
        if (res.status === 200) {
          const { data } = res.data;
          Cookies.set(AUTH_TOKEN, data.accessToken);
          Cookies.set(AUTH_TOKEN_WEB, data.accessToken);
          window.location.reload()
          originalConfig.headers.Authorization = `Bearer ${data.accessToken}`;
          return Axios(originalConfig);
        } else {
          logout();
        }
      })
      .catch(logout);
  },
);

export const sendGet = (url, params) => axiosInstance.get(url, { params }).then((res) => res.data);
export const sendPost = (url, params, queryParams) => axiosInstance.post(url, params, { params: queryParams }).then((res) => res.data);
export const sendPut = (url, params) => axiosInstance.put(url, params).then((res) => res.data);
export const sendPatch = (url, params) => axiosInstance.patch(url, params).then((res) => res.data);
export const sendDelete = (url, params) => axiosInstance.delete(url, { params }).then((res) => res.data);
export const sendPostFile = (url, params, queryParams) => axiosInstance.post(url, params, {
  headers: { 'Content-Type': 'multipart/form-data' },
  params: queryParams,
});
